import Vue from 'vue';

const saveIncompleReport = (newTireReport) => {
    const incompleteReportsValue = Vue.localStorage.get('incompleteReports', '{}')
    const incompleteReports =JSON.parse(incompleteReportsValue)
    const newIncompleteReports = { ...incompleteReports, [newTireReport.tireReportId]: newTireReport }
    Vue.localStorage.set('incompleteReports', JSON.stringify(newIncompleteReports))
}

const deleteIncompleReport = (tireReportId) => {
    const incompleteReportsValue = Vue.localStorage.get('incompleteReports');
    if (!incompleteReportsValue) return;
    let incompleteReports = JSON.parse(incompleteReportsValue)
    if (incompleteReports.hasOwnProperty(tireReportId)) {
        delete incompleteReports[tireReportId];
        Vue.localStorage.set('incompleteReports', JSON.stringify(incompleteReports))
    }
}

const getIncompleteReport = (tireReportId) => {
    const incompleteReportsValue = Vue.localStorage.get('incompleteReports');
    if (!incompleteReportsValue) return null;
    const incompleteReports = JSON.parse(incompleteReportsValue)
    return incompleteReports.hasOwnProperty(tireReportId) ? incompleteReports[tireReportId] : null
}

const getIncompleteReports = () => {
    const incompleteReportsValue = Vue.localStorage.get('incompleteReports');
    if (!incompleteReportsValue) return [];
    const incompleteReports = JSON.parse(incompleteReportsValue)
    return Object.keys(incompleteReports).map(tireReportId => incompleteReports[tireReportId])
}

export {
    saveIncompleReport,
    deleteIncompleReport,
    getIncompleteReport,
    getIncompleteReports,
}